import axios from 'axios';

const http = axios.create({
  baseURL: "https://api.site.studytravelworkips.com"
});

export default http;